module.exports = __webpack_public_path__ + "img/ico-swiper-btn-next.7c897e8a.svg";